var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-window"},[_c('div',{staticClass:"loading-window-inner"},[_c('a-spin',{attrs:{"size":"large"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }